import React from "react";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import axios from "axios";
import { ThemeProvider } from "@mui/material/styles";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import { setCookie, getCookie } from "./utils/cookies.js";
import Money from "./pages/Money";
import Spending from "./pages/Spending";
import CarbonFootprint from "./pages/CarbonFootprint";
import theme from "./styles/customTheme";
import CssBaseline from "@mui/material/CssBaseline";
import Login from "./pages/Login";
import ScrollToTop from "./components/ScrolltoTop";
import { getURLBase, isMobile } from "./utils/helperFns.js";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      name: "",
      gid: "invalid",
      hasActiveAccounts: true,
      redirect: false,
    };
  }

  sendTLCode = (code, g) => {
    console.log("Sending gid:: ", g);
    let u = getURLBase(true) + "/tlnewaccount";
    axios.post(u, { gid: g, tlcode: code }).then((response) => {
      return response.data;
    });
  };

  sendMHCode = (code, g) => {
    let u = getURLBase(true) + "/mhnewaccount";
    axios.post(u, { gid: g, mhcode: code }).then((response) => {
      return response.data;
    });
  };

  onLoginSuccess = (g, n, hasActiveAccounts) => {
    // alert(g)
    axios.post(getURLBase(true) + "/user", { gid: g }).then((response) => {
      let email = response.data.body.email;
      // alert(email)
      let device_type;
      if (isMobile()) {
        device_type = "mobile";
      } else {
        device_type = "desktop";
      }
      window.userGuiding.identify(email, {
        device_type: device_type,
      });
    });
    console.log(n, "name");
    setCookie("gid", g, 1);
    setCookie("name", n, 1);
    setCookie("hasActiveAccounts", hasActiveAccounts, 1);
    this.setState({
      name: n,
      gid: g,
      hasActiveAccounts: hasActiveAccounts,
      redirect: true,
      user_guid_code: `(function(g,u,i,d,e,s){g[e]=g[e]||[];var f=u.getElementsByTagName(i)[0];var k=u.createElement(i);k.async=true;k.src='https://static.userguiding.com/media/user-guiding-'+s+'-embedded.js';f.parentNode.insertBefore(k,f);if(g[d])return;var ug=g[d]={q:[]};ug.c=function(n){return function(){ug.q.push([n,arguments])};};var m=['previewGuide','finishPreview','track','identify','triggerNps','hideChecklist','launchChecklist'];for(var j=0;j<m.length;j+=1){ug[m[j]]=ug.c(m[j]);}})(window,document,'script','userGuiding','userGuidingLayer','523343536ID');  `,
    });
  };

  onLogoutSuccess = () => {
    this.setState({
      name: "invalid",
      gid: "invalid",
      hasActiveAccounts: false,
      redirect: false,
      user_guid_code: null,
    });
  };

  componentDidCatch() {
    //add scrollar to body if its removed
    document.body.style.overflow = "auto";
  }

  render() {
    // const { redirect } = this.state;
    window.onload = function () {
      window.history.replaceState(null, "Wyzr", "/");
    };
    const extractHash = () => {
      if (window.location.href.indexOf("#") >= 0)
        window.location = window.location.href.replace("#", "?");
      else window.location = window.location.href + "?";
    };
    window.onhashchange = extractHash;
    if (window.location.href.indexOf("#") >= 0) extractHash();

    let params = new URLSearchParams(document.location.search.substring(1));
    let code = params.get("code");
    let g = getCookie("gid");
    if (code) {
      if (params.has("status")) {
        this.sendMHCode(code, g);
      } else {
        this.sendTLCode(code, g);
      }
      return (
        <div>
          <Typography variant="h6" style={{ marginLeft: 20 }}>
            You have successfully added your account to Wyzr. We will email you
            in a few minutes when your account is ready. That gives you enough
            time to grab a cup of tea :) Click{" "}
            <Link href="https://wyzr.co.uk">here</Link> to go back to Wyzr.
          </Typography>
        </div>
      );
    }

    if (this.state.gid === "invalid") {
      return (
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Login loginSuccess={this.onLoginSuccess} />
        </ThemeProvider>
      );
    }

    //else
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <ScrollToTop />
          {/* {redirect ? <Redirect to="/dashboard" /> : ""}
          <Switch>
          <Route exact path="/dashboard">
          <Header />
          <Sidebar />
          <Navbar page="home" />
          <Home />
        </Route> */}

          {/* <Route exact path="/">
          <Login loginSuccess={this.onLoginSuccess} />
            </Route> */}

          {/* remove this when login enabled */}
          <Header name={this.state.name} />
          {/* <script> */}
          {/* {this.state.user_guid_code} */}
          {/* </script> */}
          <Sidebar />
          <Switch>
            <Route exact path="/home">
              <Navbar page="home" path="/home" name={this.state.name} />
              <Home gid={this.state.gid} />
            </Route>

            <Route exact path="/profile">
              <Navbar page="profile" path="/profile" name={this.state.name} />
              <Profile gid={this.state.gid} logout={this.onLogoutSuccess} />
            </Route>

            {/* / remove this when login enabled ended */}
            <Route exact path="/money/investments">
              <Navbar
                page="money"
                path="/money/investments"
                name={this.state.name}
              />
              <Money tab="investments" gid={this.state.gid} />
            </Route>

            <Route exact path="/money/sweep">
              <Navbar page="money" path="/money" name={this.state.name} />
              <Money
                tab="accounts"
                max_save={true}
                openSweep={true}
                gid={this.state.gid}
              />
            </Route>

            <Route exact path="/money">
              <Navbar page="money" path="/money" name={this.state.name} />
              <Money tab="accounts" gid={this.state.gid} />
            </Route>

            <Route exact path="/spending/budget">
              <Navbar
                page="spending"
                path="/spending/budget"
                name={this.state.name}
              />
              <Spending tab="budget" gid={this.state.gid} />
            </Route>

            <Route exact path="/spending">
              <Navbar page="spending" path="/spending" name={this.state.name} />
              <Spending tab="spending" gid={this.state.gid} />
            </Route>

            <Route exact path="/carbon-footprint/take-action">
              <Navbar
                page="carbon_footprint"
                path="/carbon-footprint/take-action"
                name={this.state.name}
              />
              <CarbonFootprint tab="take_action" gid={this.state.gid} />
            </Route>

            <Route exact path="/carbon-footprint">
              <Navbar
                page="carbon_footprint"
                path="/carbon-footprint"
                name={this.state.name}
              />
              <CarbonFootprint tab="carbon_footprint" gid={this.state.gid} />
            </Route>
          </Switch>
        </Router>
      </ThemeProvider>
    );
  }
}

export default App;
